import { render } from "./PreLoader.vue?vue&type=template&id=04b296ed&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=04b296ed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b296ed"]])

export default __exports__